import React, { Component } from 'react'
import { object, func, string } from 'prop-types'
// import { Link } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import './Login.scss'
import { sendOTP, resendOTP } from '../../modules/User'
import { changePopup } from '../../modules/Main'

class Otp extends Component {
  static defaultProps = {
    user: { errorLogin: '', loginRequest: false },
    closePortal: () => {},
    tampEmail: '',
  }

  static propTypes = {
    sendOTP: func.isRequired,
    changePopup: func.isRequired,
    closePortal: func,
    user: object,
    tampEmail: string,
  }

  state = {
    fields: {
      otp1: '',
      otp2: '',
      otp3: '',
      otp4: '',
    },
    error: '',
  }

  handleOnFieldChange = (e) => {
    const name = e.target.name
    const vals = e.target.value

    const afterSlice = vals.replace(`${this.state.fields[`${name}`]}`, '')
    this.setState({
      fields: ({ ...this.state.fields, ...{ [`${name}`]: afterSlice } }),
    }, () => {
      const index = Number(name.replace('otp', ''))
      if (this.state.fields[`${name}`] !== '') {
        if (index < 4) {
          document.querySelector(`#otp${index + 1}`).focus()
        }
      } else if (index > 1) {
        document.querySelector(`#otp${index - 1}`).focus()
      }
    })
  }

  handleOTP = () => {
    const { user } = this.props
    if (this.state.error === '') {
      const tifOptions = Object.keys(this.state.fields).map((key) => {
        const num = Number(this.state.fields[key])
        if (!num || isNaN(num)) {
          this.setState({
            error: 'Kode OTP salah',
          })
          return false
        }
        return true
      })

      const filtered = tifOptions.filter(x => x === false)
      if (filtered.length === 0) {
        const variables = {
          code: Number(
            `${this.state.fields.otp1}${this.state.fields.otp2}${this.state.fields.otp3}${this.state.fields.otp4}`),
          email: user.tampEmail,
        }
        this.props.sendOTP(variables)
      }
    }
  }

  clearState = () => {
    this.setState({
      fields: {
        otp1: '',
        otp2: '',
        otp3: '',
        otp4: '',
      },
      error: '',
    })
  }

  handleResendOTP = () => {
    const { tampEmail } = this.props
    this.props.sendOTP(tampEmail)
  }

  render() {
    const { user } = this.props
    const { fields, error } = this.state
    return (
      <div className='login__wrapper clearfix'>
        <h2>Masuk ke Minapoli</h2>
        <p className='otp__subtitle'>Masukan kode verifikasi yang
dikirim ke nomor handphone Anda
          <a className='resend__otp' onClick={this.handleResendOTP}>Kirim lagi &gt;</a>
        </p>
        { error !== '' && <div className='alert alert-danger'>{error}</div>}
        { user.errorOtp !== '' && <div className='alert alert-danger'>{user.errorOtp}</div>}
        <div className='login__form noBor'>
          <div className='row'>
            <div className='rl-cl-l-3'>
              <input
                id='otp1'
                onChange={this.handleOnFieldChange}
                value={fields.otp1}
                className='otp__input' min='0' max='9' maxLength='1' name='otp1'
                type='number' />
            </div>
            <div className='rl-cl-l-3'>
              <input
                id='otp2'
                onChange={this.handleOnFieldChange}
                value={fields.otp2}
                className='otp__input' min='0' max='9' maxLength='1' name='otp2'
                type='number' />
            </div>
            <div className='rl-cl-l-3'>
              <input
                id='otp3'
                onChange={this.handleOnFieldChange}
                value={fields.otp3}
                className='otp__input' min='0' max='9' maxLength='1' name='otp3'
                type='number' />
            </div>
            <div className='rl-cl-l-3'>
              <input
                onChange={this.handleOnFieldChange}
                value={fields.otp4}
                id='otp4'
                className='otp__input' min='0' max='9' maxLength='1' name='otp4'
                type='number' />
            </div>
          </div>

          <div className='row'>
            <div className='rl-cl-l-12 clearfix'>
              <button
                type='button'
                disabled={user.otpRequest ? 'disabled' : ''}
                className='login__button moreTop'
                onClick={this.handleOTP}>Verifikasi</button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  user: state.user,
  tampEmail: state.user.tampEmail,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  sendOTP,
  changePopup,
  resendOTP,
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Otp)



// WEBPACK FOOTER //
// ./src/common/Auth/Otp.js